import { getQueryClient } from '@/lib/providers/TanstackQueryProvider';
import { APIClient } from '@starsoft/common/services';
import Router from 'next/router';

const commonInstance = new APIClient(
  process.env.NEXT_PUBLIC_BASE_API,
  process.env.NEXT_PUBLIC_TENANT_ID,
  Router,
  getQueryClient(),
);

const baseAPI = commonInstance.instance;

export default baseAPI;
